"use client";

import { CalendarPlus } from "lucide-react";

type Props = {
  filename: string;
  ics: string;
  confirmed: boolean;
};

export function FestivalCalendarDownloadButton({
  filename,
  ics,
  confirmed,
}: Props) {
  function handleClick() {
    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-white/30 px-4 py-2 text-[12px] font-semibold text-white no-underline hover:bg-white/10"
    >
      <CalendarPlus className="h-4 w-4" aria-hidden="true" />
      {confirmed ? "Add to calendar" : "Download typical dates"}
    </button>
  );
}
